import React, { useState, useEffect } from "react";
import moment from 'moment';
import ScrollToBottom  from 'react-scroll-to-bottom';


import Message from "./Message";
import SendBox from "./SendBox";
import ActionsButton from './ActionsButton';
import AutoResponsesDrawer from './AutoResponsesDrawer';
import Disposition from './Disposition';
import ChatSkeleton from './ChatSkeleton';
import { makeStyles } from "@material-ui/core/styles";
import Chip from '@material-ui/core/Chip';
import clsx from 'clsx';

import { useDispatch, useSelector,shallowEqual } from 'react-redux';
import * as contactsActions from '../../../state/contacts/actions';
import * as contactsSelector from '../../../state/contacts/selectors';
import * as authSelectors from '../../../state/auth/selectors';
import * as channelActions from '../../../state/channels/actions';
import ChatOffline from "./ChatOffline";
import Api from '../../../state/Api';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import HomeIcon from '@material-ui/icons/Home';
import WarningIcon from '@material-ui/icons/Warning';
import { green, grey, red } from "@material-ui/core/colors";
import { getContactClientInfo } from '../../../state/contacts/selectors';
import {  Avatar, CardHeader, CardContent, List, ListItem, ListItemText, Paper, Typography, CardActions, Fab, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, TextField, Button, Box, Tooltip } from "@material-ui/core";
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import Bubble from './Bubble';
import CampaignTabs from "./CampaignTabs";
import SendBoxLive from "./SendBoxLive";
import MessageLive from "./MessageLive";

const useStyles = makeStyles(theme => ({
	  rightContainer: {
        position: 'relative',
        flex: 1,
        backgroundColor: 'rgba(230,220,210,0.9)',
        backgroundRepeat: "repeat",
        bottom: 0,
        top: 0,
        overflow: "auto"
    }, 
	  followB: {
      color: '#ffcc00',
      backgroundColor: 'red',
      content: '•'
    },
    pointer : {
      cursor: 'pointer'
    },
    panelContainer : {
      backgroundColor : 'white',
      color: '#000',
      padding : '10px',
      height : '122px',
      borderBottom : '1px solid #5f5f5f',
      display : 'flex',
      textDecoration: 'none',
      flexDirection : 'row'
    },
    recording : {
      background: '#f50057',
      '&:hover': {
        backgroundColor: '#f50057',
        
      }
    },
    panelTitle : {
      fontSize : '24px'
    },
    panelDescription : {
      fontSize : '14px'
    },
    category : {
      float : 'right',
      width : '100%'
    },
    price : {
      float: 'right',
      marginTop : '16px',
      color : 'blue',
      width : '100%'
    },
    description : {
      width : '50%',
      float : 'left'
    },
    imgContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      // position: 'absolute',
      zIndex: 1,
      maxWidth: '330px',
      maxHeight: '330px',
      overflow: 'hidden'
    },
    referal : {
      paddingBottom : 0,
      marginBottom : '-8px !important'
    },
    rightSide : {
      float: 'right',
      width : '50%',
      textAlign : 'right'
    },
    panelImage :  {
      width : '100px',
      float : 'left',
      marginRight : '10px',
      maxHeight : '105px'
    },
    leftPanel : {

    },
    rightPanel : {
      float: 'left',
      flex :1
    },
    chatItemPrimaryText: {
      color: '#000',
      flexDirection: 'right'
    },
    chatItemSecondaryText: {
      fontSize: '0.7em',
      color: '#999',
      flexDirection: 'right'
    },
    bubbleColor : {
      color: '#000000'
    },
    priceSpan : {
      color : '#2196f3'
    },
    anteriores : {
      position: 'absolute', 
      marginTop: 5, 
      background: '#FFFFFF', 
      zIndex: 999,
      border : '1px solid #f44336' 
    },
    rootSendBox: {
      '& .MuiInputBase-root': {
        height : 80
        // justifyContent: 'center',
        // alignItems: 'center'
      },
    },
    fabButton: {
      position: 'absolute',
      zIndex: 1,
      bottom: 40,
      left: 0,
      margin: '0 auto',
    },
    iconSize : {
      fontSize : '16px'
    },
    rootText : {
      height : '80px'
    },
    sendButton : {
      float :'right',
      cursor : 'pointer'
    },
    customListItemText: {
      '& .MuiListItemText-multiline': {
        // Your custom styles here
        whiteSpace: 'normal', // Example: Ensure text wraps
        marginTop: '16px',   // Example: Adjust line height
      },
    }
}))

const ConversationLive = ( props ) => {

  const me = useSelector(authSelectors.getMe(), shallowEqual);
  //const client = useSelector(getContactClientInfo(props.contact.id));
  const classes = useStyles();
  const dispatch = useDispatch();
  const [outgoingMessage, setMessage] = useState('');
  const allMessages = props.conversation;
  const selectedContact = null;
  const [open, setOpen] = useState(false);
  const [isOpenResponses, setOpenResponses] = useState(false);
  const [respuestas, setRespuestas] = useState([]);
  const [mensajePredef, setMensajePredef] = useState('');
  const [imagenesPredef, setImagenesPredef] = useState([]);
  const [dataPanel, setDataPanel] = useState({})
  const [newPdf, setNewPdf] = useState(false);
  const [newMsg, setNewMsg] = useState('');
  const [anterioresClicked, setAnterioresClicked] = useState(false);
  const handleProfile = props.handleProfile;

  const today = moment();
  const tieneSalientes = allMessages.some((message) => { return message.outbound && !message.isSecret && moment(message.fecha).isSame(today, 'day')  } );
  const [linkUtms, setLinkUtms] = useState(false);
  const [esTabPrincipal, setEsTabPrincipal] = useState(true);
  const sendMessage = (e) => {
    dispatch(contactsActions.sendMessage(e))
    setMessage('');
  }

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  /*
  const handleNewResponse = () => {
    Api.req.get(`/prospectos/campaigns/${props.contact.campaignid}/hsm`)
    .then((response) => {
       setRespuestas(response.data.data)
    });
  }*/


  const handlePdfClose = () => {
    setNewPdf(false)
  }

  const handlePdfFile = () => {
    setNewPdf(true);
  }

  const handleOnClose = () => {
    setOpen(false);
  }

  const handleAutoResponseClose = () => {
    setOpenResponses(false);
  }

  const getSubstring = (paramStr) => {
    if(paramStr.length > 15){
      return paramStr.substring(0,15) + '...';
    }else{
      return paramStr;
    }

  }

  const getCheckIcon = (boolean) => {
    if (boolean) {
      return <CheckCircleIcon color="primary" style={{ verticalAlign: 'bottom' }} />
    } else {
      return ''
    }

  }

  const handleNewMsg = (msg) => {
    setNewMsg(msg)
  }

  const handleCreoNewMsg = () => {
    setNewMsg('')
  }

  const getName = (name,surname) => {
    if(surname == null){
      return name ;
    }else{
      return name + ' ' + surname;
    }
    
  }

  const getTitle = (name, surname, isStaff,campaignName, calledId,source) => {
    return (<div className={classes.pointer} onClick={handleProfile} > {getName(name, surname)}  {getCheckIcon(isStaff)}  {source == 'whatsapp' ? <div style={{ float: 'right', height: '40px', marginRight: '20px', textAlign: 'right' }} >Origen : {campaignName} <br /> {calledId}</div> : '' }    </div>  )
  }

  const handleMessageDue = (d) => {
    return !moment(d).isBefore(moment());
  }

  const verAnteriores = () => {
    dispatch(contactsActions.fetchMessages(props.contact, me.username, true));
    setAnterioresClicked(true)
  }

  const handleSendTevecomprasLink = () => {

    setLinkUtms(true)
  }

  const handleCloseModalutms = () => {
    setLinkUtms(false)
  }

  const handleTabChange = (tabPrincipal) => {
    setEsTabPrincipal(tabPrincipal)
  }
 
  const getReferenceInfo = (image, caption, timestamp, url,media_type, media_url) => {

    const getLink = () => {
      if (media_type == 'IMAGE' || media_type == 'CAROUSEL_ALBUM'){
        return media_url;
      }else{
        return image;
      }
    }

    return <ListItem> 
              <Bubble style={{ width: 300 }}>
                <a href={url} target="_blank">
                  <div className={classes.imgContainer}>
                    <img width={380} src={getLink() } alt="" />
                  </div>
                </a>
                <br />
                <div className={classes.chatItemPrimaryText}>{caption}</div>
                
                <div className={classes.chatItemSecondaryText}>{moment(timestamp).calendar()}</div>
              </Bubble>
            </ListItem>
  }

    return (
      <>
     
        <>
          <ScrollToBottom mode="bottom" sticky="true" className={classes.rightContainer} followButtonClassName={classes.followB} >
            <CardContent>
                <List>
                  {
                    allMessages.map((message, index, arr) => {
                      const isDayChange = moment(message.fecha).isSame(arr[index > 0 ? index - 1 : index].fecha, 'day');
                      const isAgentChange = message.agentId === arr[index > 0 ? index - 1 : index].agentId;
                      const direction = message.host || message.assistant ? 'row-reverse' : 'row'

                      return (
                        <React.Fragment key={index}>
                          
                        <ListItem 
                          key={message.id}
                          button={false} 
                          style={{flexDirection: direction, marginTop: 1, marginBottom: 1 }}
                          className={clsx( {
                            [classes.customListItemText] : true ,
                            [classes.referal]: message.messagetype == "referral"
                          })}
                        >
                          <MessageLive
                            handleGuardoDatos={props.handleGuardoDatos}
                            key={message.id}
                            author={message.from}
                            message={message.msg}
                            inbound={message.inbound}
                            calledid={message.calledid}
                            agentId={me.username}
                            read={message.read}
                            user={message.user}
                            delivered={message.delivered}
                            OriginMessageAttachment={message.originAttachmentURL}
                            text={message.text}
                            timestamp={message.timestamp}
                            outbound={message.host || message.assistant}
                            isSecret={message.isSecret}
                            readBy={message.ReadByAgent}
                            isAgentChange={isAgentChange}
                            messageReferenceInfo={message.messageReferenceInfo}
                            messageObject={message}
                          />
                        </ListItem>
                        </React.Fragment>
                      )
                    })
                  }
                </List> 
            {/* { !sticky && <button onClick={ scrollToBottom }>Click me to scroll to bottom</button> } */}
            </CardContent>
          </ScrollToBottom>
            <CardActions style={{ opacity: 1, zIndex: 100 }}>
                <>
                  <SendBoxLive socket={props.socket} classes={classes} />
                </>
            </CardActions>
          </>
  
      </>
    )
}

export default ConversationLive;